console.log("ENV: ", process.env.NODE_ENV)
const ENV = process.env.NODE_ENV === "development" ? false : true;
export const API_BASE_URL =  ENV === true 
                            ? 'https://be-mesu-2026-962569569378.us-east1.run.app'
                            : 'https://be-mesu-2026-962569569378.us-east1.run.app';

console.log("RUTA:", API_BASE_URL)